import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const svgAnimate = () => {
  const svgsContainer = document.querySelector('.svg-animate');

  if (svgsContainer) {
    const titles = svgsContainer.querySelectorAll('h2');
    const svgStack = document.querySelector('.svg-stack');
    const svgSpin = document.querySelector('.svg-spin');
    const svgSnake = document.querySelector('.svg-snake');
    const svgSquare = document.querySelector('.svg-square');

    const animateSvgs = gsap.timeline({
      repeat: -1,
      repeatDelay: 5,
      scrollTrigger: {
        trigger: svgsContainer,
        start: 'top+=100px bottom',
        toggleActions: 'play none none reset',
      }
    });

    const stack = (el) => {
      const paths = el.querySelectorAll('path');

      const tl = gsap.timeline();
      tl.from(paths, {
        autoAlpha: 0,
        y: -30,
        stagger: {
          each: 0.2,
          ease: 'power1.inOut',
          from: 'end',
        }
      });
      return tl;
    };

    const spin = (el) => {
      const svg = el.querySelector('svg');
      const paths = el.querySelectorAll('path');

      const tl = gsap.timeline();
      tl.from(svg, {
        autoAlpha: 0,
        duration: 0.8,
        rotation: 360,
        ease: 'power1.out',
      })
        .from(paths, {
          autoAlpha: 0,
          stagger: {
            each: 0.03,
            from: 'end',
          },
        }, 0);
      return tl;
    };

    const snake = (el) => {
      const paths = el.querySelectorAll('path');

      const tl = gsap.timeline();
      tl.from(paths, {
        autoAlpha: 0,
        y: -30,
        stagger: {
          each: 0.1,
        },
      });
      return tl;
    };

    const square = (el) => {
      const svg = el.querySelector('svg');
      const tab = el.querySelector('.svg-square__tab');

      const tl = gsap.timeline();
      tl.from(svg, {
        autoAlpha: 0,
        duration: 0.6,
        rotation: -90,
        ease: 'power3.InOut',
      })
        .from(tab, 0.4, {
          y: -75
        }, 0.4);
      return tl;
    };

    const titleReveal = () => {
      const tl = gsap.timeline();
      titles.forEach((title) => {
        tl.from(title, {
          autoAlpha: 0,
          x: -30,
        }, '<60%');
      });
      return tl;
    };

    const stackAnimation = stack(svgStack);
    const spinAnimation = spin(svgSpin);
    const snakeAnimation = snake(svgSnake);
    const squareAnimation = square(svgSquare);
    const titleAnimation = titleReveal();

    animateSvgs
      .add(stackAnimation)
      .add(spinAnimation, '>-80%')
      .add(snakeAnimation, '>-50%')
      .add(squareAnimation, '>-50%')
      .add(titleAnimation, 0.2);
  }
};

export default svgAnimate;
